<template>
  <div class="container_active">
          <div class="box_lg_br">
                    <div class="box_svg">
                        <img src="@/assets/check.svg" alt="">
                        <p>{{get_local_string.string_101}}</p>
                    </div>
                    <form @submit.prevent="getMobile_num()"  class="active_code">
                        <!-- <input type="text" class="uk-input" name="" id="phone"> -->
                        <div class="text-center phone_wrap">
                             <vue-tel-input @validate="ok($event)" @input="keys()"  v-model="phone" ></vue-tel-input>
                             <span :class="{ correct: valid }" class="valid_span">{{this.msg_valid}}</span>
                        </div>
                        <div class="text-center">
                            <button :disabled="!valid" class="yes" type="submit"><i class="fas fa-sms"></i> <span>{{get_local_string.string_63}}</span></button>
                        </div>

                 <b-loading :is-full-page="isFullPage" v-model="isLoading"  animation="faed" >
                <b-icon
                    pack="fas"
                    icon="spinner"
                    size="is-large"
                    custom-class="fa-spin"
                    >
                </b-icon>
            </b-loading>
                      </form>
                </div>
    </div>
</template>

<script>
import { mapActions , mapGetters } from 'vuex';
// import VueTelInput from 'vue-tel-input';
export default {
   name:'activemobileApp',
   data(){
       return{
           phone:'',
           valid:null,
           msg_valid:'',
           isLoading: false,
           isFullPage: false,
       }
   }
   ,methods:{
       ...mapActions({
           getMobileNumber:'getMobileNumber'
       }),
       getMobile_num(){
           this.openLoading();
           let pasrse =this.phone.replace(/\s/g, ""); 
           this.getMobileNumber(pasrse).then(()=>{
               this.isLoading = false
               this.$router.replace('/ActiveCode');
           }).catch(()=>{
               this.isLoading = false
               this.$router.replace('/ActiveMobile');
           });
       },
       keys(){
           if(this.phone== '')
           {
               this.msg_valid = '';
           }
       },
       ok(event){
           if(event.valid == false || event.valid == undefined && this.valid != null){
               this.msg_valid = 'Number is Invalid !';
               this.valid = event.valid;
           }
           else if(event.valid == true)
           {
               this.msg_valid = 'Number is valid !';
               this.valid = event.valid;
           }
       },
       openLoading() {
                this.isLoading = true;
       }
   },
   computed:{
        ...mapGetters({
             get_local_string:'get_local_string'
        })
    },
}
</script>


<style  scoped>

.phone_wrap{
    text-align: center;
    margin-bottom: 30px;
}
.container_active{
    max-width: 600px;
    margin: 0 auto;
    padding-top: 160px;
}
.active_wrap {
    padding: 50px 0px;
}
.box_svg {
    /* margin-top: 50px; */
    height: 160px;
    text-align: center;
    color: gray;
}
.box_svg p {
    display: block;
    margin-top: 20px;
    margin-bottom: 20px;
    
}
.box_svg img {
    height: 100%;
    width: 100%;
    display: block;
}

button.yes {
    padding: 8px 20px;
    border-radius: 30px;
    color: white;
    font-weight: 500;
    letter-spacing: 0.4px;
    text-transform: capitalize;
    text-align: center;
    border: none;
    transition: 0.3s linear;
}
button.yes:disabled{
        background-color: #6c757d99;
}
a:hover {
    text-decoration: none;
}
button.yes {
    background-color: #02bfa6;
}
.felx_ok a.no {
    background-color: #f50057;
}
.valid_span{
    color: #f50057;
    position: absolute;
    left: 20px;
    top: 54px;
    font-size: 13px;
    font-weight: 600;

}
.valid_span.correct{
    color: #02bfa6;
}
.felx_ok button i {
    font-size: 20px;
    margin-right: 4px;
}

.box_lg_br {
 height: 100%;
    padding: 60px 14px;
    box-shadow: 1px 3px 14px white;
    background-color: white;
    border-radius: 20px;
}

/*  */
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type="number"] {
    -moz-appearance: textfield;
}

form {
    padding: 1rem;
    border-radius: 4px;
    /* box-shadow: 0 2px 4px rgb(0 0 0 / 10%); */
    max-width: 400px;
    background: #fff;
    margin-top: 100px;
    margin: 50px auto 0px auto;
    position: relative;
}
form .form-control {
    display: block;
    height: 50px;
    margin-right: 0.5rem;
    text-align: center;
    font-size: 1.25rem;
    min-width: 0;
}
form .form-control:last-child {
    margin-right: 0;
}
/*  */

@media (max-width: 992px) {
    form {
        font-size: 14px;
        flex-direction: column;
        margin-top: 70px;
    }
    button.yes {
        margin-top: 10px;
    }
}

</style>